import { render } from "./PiaAssistant.vue?vue&type=template&id=acd4969a&scoped=true"
import script from "./PiaAssistant.vue?vue&type=script&lang=js"
export * from "./PiaAssistant.vue?vue&type=script&lang=js"

import "./PiaAssistant.vue?vue&type=style&index=0&id=acd4969a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acd4969a"]])

export default __exports__